export default {
    posts: {
        // C
        confirmActivatePost: 'Are you sure you want to activate this post?',
        confirmPostDeactivationText: 'This will deactivate this post from Studio.<br/><br/> Are you sure you want to continue?',
        confirmPostDeactivationTitle: 'confirm post deactivation',
        convertToRegularPostText: 'Make Global Community Post',
        convertToRegularPostTitle: 'Convert to Regular Post',

        // E
        editDividerInfo: 'Post info',
        editDividerTitle: 'Community Post',
        editingPost: 'Editing Post',
        editVisibleOrganizations: 'Visible for Channels:',

        // G
        globalPost: 'Global Post',

        // N
        noOrganizationsFound: 'No channels found',
        noPostsFound: 'No community posts found.',

        // P
        postUpdated: 'Community Post updated',

        // T
        trashedMessagePostDeactivated: 'This post has been deactivated.',

        // V
        visibleFor: 'Visible For',
    }
}
